// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"8d00ce61","453":"d978b776"}[chunkId] + ".chunk.js";
};